import { Nillable } from '@web/utils';
import {
  DictionaryCountry,
  PhoneNumberWithPrefix,
} from '@web/shared/module/dictionary';

export class PublicCartBillingAddress {
  public constructor(
    private readonly data: {
      firstName?: Nillable<string>;
      lastName?: Nillable<string>;
      phone?: Nillable<PhoneNumberWithPrefix>;
      email?: Nillable<string>;
      streetLine1?: Nillable<string>;
      streetLine2?: Nillable<string>;
      postCode?: Nillable<string>;
      city?: Nillable<string>;
      state?: Nillable<string>;
      companyName?: Nillable<string>;
      companyNip?: Nillable<string>;
      country?: Nillable<DictionaryCountry>;
    },
  ) {}

  public get firstName(): Nillable<string> {
    return this.data.firstName;
  }

  public get lastName(): Nillable<string> {
    return this.data.lastName;
  }

  public get phone(): Nillable<PhoneNumberWithPrefix> {
    return this.data.phone;
  }

  public get email(): Nillable<string> {
    return this.data.email;
  }

  public get streetLine1(): Nillable<string> {
    return this.data.streetLine1;
  }

  public get streetLine2(): Nillable<string> {
    return this.data.streetLine2;
  }

  public get postCode(): Nillable<string> {
    return this.data.postCode;
  }

  public get city(): Nillable<string> {
    return this.data.city;
  }

  public get state(): Nillable<string> {
    return this.data.state;
  }

  public get companyName(): Nillable<string> {
    return this.data.companyName;
  }

  public get companyNip(): Nillable<string> {
    return this.data.companyNip;
  }

  public get country(): Nillable<DictionaryCountry> {
    return this.data.country;
  }
}
